import { Routes } from '@angular/router';
import { verificationGuard } from '@core/auth/verification.guard';
import { adminGuard } from '@core/auth/admin-role.guard';
import { authenticatedGuard } from '@core/auth/authenticated.guard';
import { adminLegacyTabGuard } from '@features/admin/admin-legacy-tab.guard';
import { loadFeature, loadFeatures } from '@core/i18n/translate-feature-loader';

export const routes: Routes = [
  {
    path: 'login',
    resolve: { i18n: loadFeature('login') },
    loadComponent: () =>
      import('@features/auth/login/login.component').then((m) => m.LoginComponent),
  },
  {
    path: 'register',
    resolve: { i18n: loadFeature('register') },
    loadComponent: () =>
      import('@features/auth/register/register.component').then((m) => m.RegisterComponent),
  },
  {
    path: 'verification-pending',
    canActivate: [authenticatedGuard],
    resolve: { i18n: loadFeature('verification_pending') },
    loadComponent: () =>
      import('@features/auth/verification-pending/verification-pending.component').then(
        (m) => m.VerificationPendingComponent,
      ),
  },
  {
    path: '',
    canActivate: [verificationGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        resolve: { i18n: loadFeatures('home', 'hilfe') },
        loadComponent: () => import('@features/home/home.component').then((m) => m.HomeComponent),
      },
      {
        path: 'hilfe',
        resolve: { i18n: loadFeature('hilfe') },
        loadComponent: () =>
          import('@features/hilfe/hilfe.component').then((m) => m.HilfeComponent),
      },
      {
        path: 'marktplatz',
        loadChildren: () => import('@features/marktplatz/marktplatz.routes').then((m) => m.routes),
      },
      {
        path: 'markt/shops',
        loadChildren: () => import('@features/marktplatz/markt-shop.routes').then((m) => m.routes),
      },
      {
        path: 'verzeichnis',
        loadChildren: () =>
          import('@features/verzeichnis/verzeichnis.routes').then((m) => m.routes),
      },
      {
        path: 'nachrichten',
        resolve: { i18n: loadFeature('nachrichten') },
        loadComponent: () =>
          import('@features/nachrichten/nachrichten.component').then((m) => m.NachrichtenComponent),
      },
      {
        path: 'profil',
        loadChildren: () => import('@features/profil/profil.routes').then((m) => m.routes),
      },
      {
        path: 'detail/:feedType/:id',
        resolve: { i18n: loadFeatures('detail', 'hilfe') },
        loadComponent: () =>
          import('@features/detail/detail.component').then((m) => m.DetailComponent),
      },
      {
        path: 'admin',
        canActivate: [adminGuard, adminLegacyTabGuard],
        resolve: { i18n: loadFeature('admin') },
        loadComponent: () =>
          import('@features/admin/admin.component').then((m) => m.AdminComponent),
        children: [
          {
            path: 'shop',
            resolve: { i18n: loadFeatures('profil', 'markt_shop') },
            loadComponent: () =>
              import('@features/profil/pages/profil-shops/profil-shops.component').then(
                (m) => m.ProfilShopsComponent,
              ),
          },
          {
            path: '',
            loadChildren: () => import('@features/admin/admin.routes').then((m) => m.routes),
          },
        ],
      },
    ],
  },

  { path: '**', redirectTo: '' },
];
